import { LabClient, LabModel } from "@app/api2/api";
import { BPColumn } from "@common/BPReactTable";
import { PageHeader } from "@common/PageHeader";
import { buildUrl, AppRoutes } from "../AppRoutes";
import { getInactiveFilter } from "@common/Utils";
import { Link } from "react-router-dom";
import { useTranslation2 } from "../Contexts/TranslationContext2";
import { BPDataTable3 } from "../Common/DataTable/BPDataTable3";
import { BPContainer } from "@/components/bp/bpcontainer";

interface LabsProps {
    canCreateLab: boolean;
}

export function Labs(props: LabsProps) {
    const client: LabClient = new LabClient();
    const {translations: t} = useTranslation2();

    const columns: BPColumn<LabModel>[] = [
        getInactiveFilter('showInactive', t.labView.showInactiveLabs),
        {
            Header: t.lab.name,
            accessor: 'name',
            Cell: cell => <Link to={buildUrl(AppRoutes.LabDetails, { labId: cell.row.original.id })}>{cell.value}</Link>,
        },
    ];

    // const columnDefs = convertColumns(columns);

    // const table = useBpReactTable2<LabModel>({
    //     queryKeyPrefix: 'Labs',
    //     query: async (paging, sorting, searchValue, filters) => {
    //         let showInactive = getFilterValue(filters, 'showInactive') ? true : false;
    //         let pageData = await client.pageData(paging.pageSize, paging.pageIndex + 1, sorting[0]?.id, sorting[0]?.desc ? 'desc' : 'asc', showInactive, searchValue);
    //         return { rowCount: pageData.totalRows, rows: pageData.items }
    //     },
    //     columnDefs: columnDefs,
    //     defaultSortingState: [{ id: 'name', desc: false }],
    // });


    return (
        <BPContainer>
            <PageHeader header={t.common.labs}
                buttons={props.canCreateLab ? [
                    { label: t.labView.create, to: buildUrl(AppRoutes.LabCreate, {}) }
                ] : []}
            />
            {/* <BPReactTable2 {...table }/> */}
            <BPDataTable3
                storeKey="Labs"
                defaultSortField="name"
                defaultSortAsc={true}
                enableSearch={true}
                dataSource={async (p) => {
                    let showInactive = p.filters.find(x => x.id == 'showInactive')?.value ?? false;
                    let pageData = await client.pageData(p.perPage, p.page, p.sortBy, p.sortDirection, showInactive, p.searchValue);
                    return pageData;
                }}
                columns={columns}
            />
        </BPContainer>
    );
}

